import React from "react";
import Row from "../../common/Row";
import Product from "./Product";

const Shop = () => {
    return (
        <div className="bg-gray-100 py-8 text-center space-y-4">
            <div className="text-2xl text-emerald-400 font-bold">SHOP</div>
            <div className="m-4">
                <Row spaceClass="space-x-4">
                    <Product  />
                    <Product  />
                    <Product />
                </Row>
            </div>
        </div>
    );
};

export default Shop;
